module.exports = __webpack_public_path__ + "static/media/minivan-avatar.d722b6e4.svg";